import * as firebase from 'firebase/app'
// Add the Firebase products that you want to use
import 'firebase/auth'
import 'firebase/firestore'

var firebaseConfig = {
  apiKey: 'AIzaSyD94SoQdELmApK_wocjErXCnomfcRiolWY',
  authDomain: 'sitio-alegria.firebaseapp.com',
  databaseURL: 'https://sitio-alegria.firebaseio.com',
  projectId: 'sitio-alegria',
  storageBucket: 'sitio-alegria.appspot.com',
  messagingSenderId: '447836051140',
  appId: '1:447836051140:web:0d5b987201ffa4641cdb91'
}
// Initialize Firebase
let app = firebase.initializeApp(firebaseConfig)
var db = firebase.firestore(app);

import Vue from 'vue'
import Vuex from 'vuex'

// var database = firebase.database();

import _ from 'lodash/core';
import orderBy from 'lodash/orderBy';

Vue.use(Vuex)


let cliente = JSON.parse(localStorage.getItem('cliente')) || {
  nome:'',
  telefone:'',
  endereco:'',
  observacao:'',
}

let localCliente = JSON.parse(localStorage.getItem('localCliente')) || ''



export default new Vuex.Store({
  state: {

    produtos: [
      // { id: 1, nome: 'Abacate', medida: 'unidade', incremento: 1, preco: 8, disponivel: 2 },

    ],
    pedidos: [
      
    ],
    listaPedidos: [
      
    ],

    localCliente: localCliente,

    locaisEntregas: [
      // {id:'1',nome:'Asa Norte'},
      // {id:'2',nome:'sul'},
      // {id:'3',nome:'cond1'},
      // {id:'4',nome:'cond2'},
      
    ],

    pedidosFeitoCliente: {},

    listaInfo: 
      {

        dataInicial:'', 
        dataFinal:'',
        id:'lista',
     },

    minhacesta: [],

    cliente:{...cliente}

  },

  mutations: {


    localCliente:function(state,local){  
        state.localCliente = local;
        localStorage.setItem('localCliente', JSON.stringify(local) )
    },

    cliente:function(state,cliente){  
        state.cliente = cliente;
        localStorage.setItem('cliente',JSON.stringify(cliente))
    },

    pedidosFeitoCliente:function(state,pedidosFeitoCliente){  
        state.pedidosFeitoCliente = pedidosFeitoCliente;
    },


    produto:function(state,produtos){  
        state.produtos = orderBy(produtos, [function(o) { return o.nome.toLowerCase(); }], ['asc']);
    },

    locaisEntregas:function(state,locais){  
        state.locaisEntregas = orderBy(locais, [function(o) { return o.nome.toLowerCase(); }], ['asc']);
    },


    updateproduto:function(state,produto){  
        let produtos = [...state.produtos]
        
        for (let i = 0; i < produtos.length; i++) {
          const produtoFind = produtos[i];
          if(produtoFind.id == produto.id){
            produtos[i]= {...produtoFind,...produto}
          }
        }
        state.produtos = produtos

    },

    pedidos:function(state,pedidos){
        
        pedidos.forEach(pedido=>{
          pedido._datapedido = new Date(pedido.datapedido.seconds*1000).toLocaleString("pt-br","long")
          pedido._listaid = new Date(pedido.lista.dataInicial).toLocaleDateString("pt-br",{dateStyle:"long",timeZone:"UTC"})
        })
        
        state.pedidos = pedidos

        let lista = {};

        pedidos.forEach(pedido=>{
            let pedidoslista = lista[pedido._listaid] || []
            pedidoslista.push(pedido)
            lista[pedido._listaid] = pedidoslista
        })

        let listaArray = []

        _.each(lista,(listaItem,listaId)=>{

          let produtos = {}
          listaItem.forEach(pedido=>{
              pedido.produtos.forEach( produto =>{
                    // if(produtos?.nome) return
                    // if (produto.nome.trim() == "Cogumelo Shimeji Branco") {
                    //   console.log('======  PRODUTO ========')
                    //   console.table(produto)
                    // }
                  let produtoTotal = produtos[produto.id] || {...produto,total:0}
                  produtoTotal.total =  Number(produtoTotal.total) + Number(produto.quantidade)
                  produtos[produto.id] = {...produtoTotal}
                  // if (produto.nome.trim() == "Cogumelo Shimeji Branco") {
                  //   console.log("======  PRODUTO TOTAL ========");
                  //   console.table(produtoTotal);
                  // }
              })
          })
          listaArray.push({ produtosTotal:orderBy(produtos,['nome'],['asc']), id:listaId, pedidos:[...listaItem]})
          // listaArray.push()
          // listaItem.produtosTotal = produtos
          // listaItem.id = listaId
          
        })


        state.listaPedidos = listaArray //_.map( lista, (lista,id)=> lista )


    },

    listaInfo:function(state,listaInfo){
        state.listaInfo = listaInfo
    },


    limpacesta:function(state){
      state.minhacesta = []
      localStorage.setItem('minhacesta',[])
    },

    updateCesta:function(state,{produto,quantidade}){

      let cesta = [...state.minhacesta]

      if(quantidade==0){
        cesta = _.filter(cesta,item=>item.id!=produto.id)
      }else{
        let temproduto = _.find(cesta,{id:produto.id})
        if(temproduto){
          temproduto.quantidade = quantidade
        }else{
          cesta.push({...produto,quantidade:quantidade})
        }
      }

      state.minhacesta = cesta
      localStorage.setItem('minhacesta',JSON.stringify(cesta))

    },

  },

  actions: {

    
    listaInfo:async function(ctx,lista){
     try{
        let res = await db.collection("listaInfo").doc("lista").set(lista)
        console.log(res)
        ctx.commit('listaInfo',lista)
        return res
      }catch(e){
        console.error(e);
        return false;
      }
    },


    cadastraRegiao:async function(ctx,{nome,valorMinimo}){
     try{
        let res = await db.collection("regioes").add({nome,valorMinimo})
        console.log(res)
        ctx.dispatch('getRegioes')
        return res
      }catch(e){
        console.error(e);
        return false;
      }

    },

    updateRegiao:async function(ctx,item){
     try{
        let res = await db.collection("regioes").doc(item.id).update(item)
        console.log(res)
        ctx.dispatch('getRegioes')
        return res
      }catch(e){
        console.error(e);
        return false;
      }

    },

    removeRegiao:async function(ctx,regioes){

      try{
        let res = await db.collection("regioes").doc(regioes.id).delete()
        console.log(res)
        await ctx.dispatch('getRegioes')
        return res
      }catch(e){
        console.error(e);
        return false;
      }
    },



    cadastraProduto:async function(ctx,produto){
      console.log(produto)
      try{
        delete produto.quantidade
      }catch(e){
      }
     try{
        produto.preco = Number(produto.preco.toString().replace(/,/g,'.'))
        let res = await db.collection("produtos").add(produto)
        console.log(res)
        ctx.dispatch('getProdutos')
        return res
      }catch(e){
        console.error(e);
        return false;
      }

    },

    updateProduto:async function(ctx,produto){
      try{
        delete produto.quantidade
      }catch(e){
        
      }

     try{
       if(produto.preco){
          produto.preco = Number(produto.preco.toString().replace(/,/g,'.'))
       }
        let res = await db.collection("produtos").doc(produto.id).update(produto)
        console.log(res)
        ctx.commit('updateproduto',produto)
        // ctx.dispatch('getProdutos')
       return produto
        // return res
      }catch(e){
        return false;
      }

    },



    limpaEstoque: async function(ctx){
      
      var batch = db.batch();
      db.collection("produtos").get().then(function(querySnapshot) {
        querySnapshot.forEach(function(doc) {
           batch.update(doc.ref,{ disponivel: 0 })
          });
        });
        
      await batch.commit()  
      // ctx.commit('updateproduto',{...doc.data(),disponivel:0} )
      setTimeout(()=>ctx.dispatch('getProdutos'), 3000 )

    },




    updatePedido:async function(ctx,pedido){
      
      try{
          let res = await db.collection("pedido").doc(pedido.id).update(pedido)
          console.log(res)
          ctx.dispatch('getPedidos')
          return res
        }catch(e){
          return false;
        }

    },


    removeProduto:async function(ctx,produto){
      console.log(produto)
      try{
        let res = await db.collection("produtos").doc(produto.id).delete()
        console.log(res)
        ctx.dispatch('getProdutos')
        return res
      }catch(e){
        console.error(e);
        return false;
      }
    },

    removePedido:async function(ctx,pedido){

      try{
        let res = await db.collection("pedido").doc(pedido.id).delete()
        console.log(res)
        await ctx.dispatch('getPedidos')
        return res
      }catch(e){
        console.error(e);
        return false;
      }
    },


    
    getListInfo: async function(ctx){
      try{
        let res = await db.collection("listaInfo").doc("lista").get()
        console.log(res.data())
        ctx.commit('listaInfo', res.data());

        return res
      }catch(e){
        console.error(e);
        return false;
      }
    },


    getProdutos: async function(ctx){
      try{
        let res = await db.collection("produtos").get()
        let produtos = [];
        res.forEach(function(doc) {
          // doc.data() is never undefined for query doc snapshots
          let produto = {  ...doc.data(), id:doc.id }
          produtos.push( produto );
      });

        console.log(res)
        ctx.commit('produto', [...produtos] );

        return produtos
      }catch(e){
        console.error(e);
        return false;
      }
    },


    getRegioes: async function(ctx){
      try{
        let res = await db.collection("regioes").get()
        let regioes = [];
        res.forEach(function(doc) {
          // doc.data() is never undefined for query doc snapshots
          let produto = {  ...doc.data(), id:doc.id }
          if(! produto?.valorMinimo) produto.valorMinimo = 0 //add in case we have not set yet
          regioes.push( produto );
      });

        console.log(res)
        ctx.commit('locaisEntregas', [...regioes] );

        return regioes
      }catch(e){
        console.error(e);
        return false;
      }
    },


    getPedidos: async function(ctx){
      try{
        let res = await db.collection("pedido").orderBy("datapedido", "desc").limit(90).get()
        let produtos = [];
        res.forEach(function(doc) {
          // doc.data() is never undefined for query doc snapshots
          let produto = {  ...doc.data(), id:doc.id }
          produtos.push( produto );
      });

        console.log(res)
        ctx.commit('pedidos', produtos)    
      }catch(e){
        console.error(e);
        return false;
      }
    },


    enviaPedido:async function(ctx, usuario){

      //primeiro atualizo com o status atual
      let error = false;
      let errormsg = "";
    
      let produtos = await ctx.dispatch('getProdutos');

      if(produtos == false){

        return {error:true,errormsg:"problemas de conexão com o servidor. Tente novamente!"}
      }
    
      produtosToUpdate = []

      //insiro a regiao no cliente
      usuario.regiao = _.find(ctx.state.locaisEntregas,{id:ctx.state.localCliente})

      let pedido = {
        cliente: usuario,
        pago:false,
        lista:ctx.state.listaInfo,
        datapedido: firebase.firestore.FieldValue.serverTimestamp(),
        total: ctx.getters.total+15,
        produtos: _.map(ctx.state.minhacesta, produtoCesta=>{
            let p = {...produtoCesta}
            p.valorTotal = p.preco*p.quantidade/p.incremento
            //verifico se a quantidade especificada esta de acordo com a disponivel
            let produto = _.find(produtos,{id:produtoCesta.id})
            if(produto){

              if(produto.disponivel - p.quantidade < 0){

                ctx.commit('updateCesta',{produto, quantidade:produto.disponivel})
                error = true
                
                if(produto.disponivel == 0){
                  errormsg = `O Produto <b>${produto.nome}</b> não está mais disponível esta semana. Removemos ele de sua cesta.
                  Verifique a lista de produtos de sua cesta abaixo, e  <b>confirme novamente o seu pedido</b>.`
                }else{
                errormsg = `Você solicitou <b>${p.quantidade} ${p.medida}</b> de </b>${produto.nome}</b>, porém atualmente só temos disponivel <b>${p.quantidade - produto.disponivel} ${p.medida}</b> <br />.
                 Se desejar continuar com a quantidade disponivel <b>confirme novamente o seu pedido</b> abaixo. Se preferir removelo da sua cesta, volte e edite o seu pedido`
                }

              }else{

                produtosToUpdate.push(
                  {
                    id:produto.id,
                    disponivel: firebase.firestore.FieldValue.increment(-p.quantidade) //(produto.disponivel - p.quantidade)
                  }
                )
              }

            }else{

              error = true
              errormsg = "Produto não está mais disponivél"

            }
            p.quantidadeDisponivelAntes = produto.disponivel
            delete p.disponivel
            delete p.incremento
            return p
        })
      }
      
      if(error==true){
        return {error,errormsg}
      }

      // salva peddido
      try{
        let res = await db.collection("pedido").add(pedido)
        console.log(res)
        ctx.commit('limpacesta')
        ctx.commit('pedidosFeitoCliente',pedido)
        // return {error:false,response:res} 
      }catch(e){
        console.error(e);
        return {error:true,errormsg:e}
      }
      


      //atualiza a quantidade de produtos
      let produtosToUpdate = _.map(produtosToUpdate, produto=>{
    
          return {
                  id:produto.id,
                  disponivel:produto.disponivel
                }
      })
      
    
      let allPromissesUpdateProdutos = []

      // Get a new write batch
      var batch = db.batch();

      for (let i = 0; i < produtosToUpdate.length; i++) {
          const p = produtosToUpdate[i];     
           let refDoc = db.collection("produtos").doc(p.id)
          batch.update(refDoc,p)
          // allPromissesUpdateProdutos.push( db.collection("produtos").doc(p.id).update(p) )
      }

      try{
            let res = batch.commit()//Promise.all(allPromissesUpdateProdutos)
            console.log(res)
            //  return {error:false,response:res} 
      }catch(e){
            console.error(e);
            // error = true
            // errormsg = "Erro de atualização no servidor"
          //  return {error:true,errormsg:e}
      }

      // for (let i = 0; i < produtosToUpdate.length; i++) {
      //   const p = produtosToUpdate[i];     
    
      //   try{
      //        let res = db.collection("produtos").doc(p.id).update(p);
      //        console.log(res)
      //       //  return {error:false,response:res} 
      //   }catch(e){
      //        console.error(e);
      //        error = true
      //        errormsg = "Produto não está mais disponivél"
      //       //  return {error:true,errormsg:e}
      //   }

      // }  

      return {error, errormsg}

    }

  },


  getters: {
      
      cliente(state){
         return state.cliente
      },

      listaInfo(state){
         return state.listaInfo
      },

      produtos(state){
         return state.produtos
      },
      
      locaisEntregas(state){
         return state.locaisEntregas
      },

      produtosById: (state)=>(id)=>{
         return _.find(state.produtos,{id:id})
      },


      pedidos(state){
         return state.pedidos
      },

      listaPedidos(state){
         return state.listaPedidos
      },
      listaPedidosById: (state) => (id)=>{
         return _.find(state.listaPedidos,{id})
      },

      lista(state){
        // return state.lista
          let lista = [] 
          _.forEach(state.produtos, produto=>{
            let produtoNaCesta = _.find(state.minhacesta,{id:produto.id})
            if(produtoNaCesta){
              produto.quantidade = produtoNaCesta.quantidade
            }else{
              produto.quantidade = 0
            }
            if(produto.disponivel > 0){
                lista.push(produto)
            }
          })
          return lista
      },
      
      minhacesta(state){
          return state.minhacesta
      },

      quantidadeProduto:(state)=>(id)=>{
        let produtoNaCesta = _.find(state.minhacesta,{id:id})
        if(produtoNaCesta){
          return produtoNaCesta.quantidade
        }
        return 0
      },

      total(state){
          let count = 0;
          _.forEach(state.minhacesta, produto=>{
            count += produto.preco*produto.quantidade/produto.incremento
          })
          return count;
      }
  },

  modules: {

  }

})
